"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _coreMixins = require("@vfuk/core-mixins");
var _fontFace = _interopRequireDefault(require("./partials/fontFace"));
var _normalize = _interopRequireDefault(require("./partials/normalize"));
var _fontSizes = _interopRequireDefault(require("./partials/fontSizes"));
var _formElementSuggestions = _interopRequireDefault(require("./partials/formElementSuggestions"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

// stylelint-disable property-no-vendor-prefix
var styles = (0, _styledComponents.createGlobalStyle)(function (props) {
  return (0, _styledComponents.css)(["", " html{font-family:sans-serif;box-sizing:border-box;-ms-text-size-adjust:100%;-ms-overflow-style:scrollbar;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}body{", " font-family:", ";font-weight:", ";color:", ";background-color:", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:left;}::-webkit-input-placeholder,::-moz-placeholder,:-ms-input-placeholder{color:", ";font-weight:400;}", " ", " ", ""], _normalize["default"], _coreMixins.typography.paragraph(2, false), props.theme.baseFont.fontFamily, props.theme.baseFont.fontWeight, props.theme.baseFont.color, props.theme.baseFont.backgroundColor, props.theme.color.monochrome4["default"], _fontFace["default"], _fontSizes["default"], _formElementSuggestions["default"]);
});
var _default = styles;
exports["default"] = _default;